import { authApiCall } from "../../auth";

// GET
export const getPromoCodes = () =>
  authApiCall({
    url: `/payment/get-promos/`,
    method: "get",
  });

// CREATE
export const createPromoCode = (payload) =>
  authApiCall({
    url: `/payment/promo-code/create/`,
    method: "post",
    data: payload,
  });

// UPDATE
export const updatePromoCode = (id, payload) =>
  authApiCall({
    url: `/payment/promo-code/${id}/`,
    method: "put",
    data: payload,
  });